export {default} from "./SpotlightSmall";
